




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import UserComponent from '@/components/UserComponent.vue'; // @ is an alias to /src
import UserCircleComponent from '@/components/UserCircleComponent.vue'; // @ is an alias to /src
import { StoryUser } from '../StoryUser'
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import StoriesComponent from '@/components/StoriesComponent.vue'; // @ is an alias to /src
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src
import { globalUC } from '../UserCache'

@Component({
  name: 'User',
  components: { UserComponent, UserCircleComponent, StoriesComponent, ModalWrapperComponent }
})
export default class UserView extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public targetUserId: string = null
  public targetUser: StoryUser = null

  public get loading(): boolean { return this.$store.state.loading }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }
  public get isMe(): boolean { return this.userId === this.targetUserId }

  // public functions available to the html template
  public startStorySelf(): void {
    if (this.user.phoneNumberIds.length > 0) {
      (this.$refs.StoryStartFormModalComponent as ModalWrapperComponent).show(`Record a Story About ${this.targetUser.firstName}`, 'lg', { circleUser: this.targetUser, circleId: this.targetUser.circleId, storyTellerId: this.userId, hideQuestionPicker: !this.isMe })
    } else {
      (this.$refs.PhoneNumberFormModalComponent as any).show('Add Your Phone Number to Enable Story Recording', 'md', null)
    }
  }

  public poseQuestion(): void {
    (this.$refs.StoryStartFormModalComponent as ModalWrapperComponent).show(`Pose a Question To ${this.targetUser.firstName}`, 'lg', { circleUser: this.targetUser, circleId: this.targetUser.circleId, storyTellerId: this.targetUserId })
  }

  public inThisCircle(): boolean {
    if (!this.targetUser) return false
    if (!this.isAuthenticated) return false
    return (this.targetUser.getCircle().isFollowedBy(this.userId) || this.user.isFollowing(this.targetUser.circleId))
  }

  // this.$emit('changed-modalshow', this.innerComponentName, val, this.payload); // in case parent (navbar) wants to know we open or closed modal along with inner component payload
  public async onModalShowChangeStoryStartForm(componentName: string, showing: boolean, submittedStory: boolean): Promise<void> {
    if (!showing && submittedStory) {
      // tell StoriesComponent to refresh
      await (this.$refs.StoriesComponent as StoriesComponent).refresh()
    }
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template

  // this is necessary because path changes don't reload the component nor its subcomponents
  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`${this.$options.name} pathChanged()`)
    await this.$router.go(0)
  }

  private async beforeRouteUpdate(to) {
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeRouteUpdate()`)
    console.log(to)
  } 

  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

    // get story id from URL
    this.targetUserId = this.$route.params.id

    // get user
    this.targetUser = await globalUC.get(this.targetUserId, false)
  }

}

